import { Component, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseItemComponent } from '../../common-items/BaseItem/base-item-form.component';
import { BaseItemProperties, DEFAULT_BASE_PROPERTIES } from '../../common-items/BaseItem/base-item-properties';

import { getPropsFrom } from '../../../../utils/xmlParser';

interface TextProperties {
  text: string;
  style: string;
}

@Component({
  selector: 'lfe-text-item-form',
  imports: [CommonModule],
  templateUrl: './text-item-form.component.html',
  standalone: true,
  styleUrl: './text-item-form.component.css'
})
export class TextItemFormComponent extends BaseItemComponent<TextProperties> {
  properties: BaseItemProperties & TextProperties = {
    ...DEFAULT_BASE_PROPERTIES,
    text: '',
    style: ''
  };

  currentId = computed(() => this.properties.customId || this.properties.id);

  htmlId = computed(() => `text_item_${this.currentId()}`);

  extractLocalProperties(xml: Element) {
    const props = getPropsFrom(xml);

    const customId = props['CustomID'];
    const id = props['ID'];
    const text = props['Text'] || '';
    const style = props['Style'] || '';
    const activationRule = props['ActivationRule'] || '';
    const isGenericRepeatItem = props['IsGenericRepeatItem'] === 'True';

    return {
      ...DEFAULT_BASE_PROPERTIES,
      id,
      customId,
      activationRule,
      text,
      style,
      isGenericRepeatItem
    } as BaseItemProperties & TextProperties;
  }
}
